import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'clockTime' })
export class ClockTimePipe implements PipeTransform {
  transform(
    date: Date,
    lang: string = 'en',
    markerAtStart: boolean = false
  ): string {
    if (!date) return '';

    const locale = lang === 'ar' ? 'ar-EG' : 'en-US';
    const parts = new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }).formatToParts(date);

    const get = (type: string) => parts.find(p => p.type === type)?.value ?? '';
    const time = `${get('hour')}:${get('minute')}:${get('second')}`;
    const marker = get('dayPeriod');

    return markerAtStart ? `${marker} ${time}` : `${time} ${marker}`;
  }
}